import type { ReactNode } from 'react'
import { CircleAlert, Inbox, LoaderCircle } from 'lucide-react'

export function EmptyState({ icon, title, children, action, className = '' }: { icon?: ReactNode; title: ReactNode; children?: ReactNode; action?: ReactNode; className?: string }) {
  return (
    <div className={`flex flex-col items-center justify-center text-center gap-2 py-10 px-6 ${className}`}>
      <div className="w-10 h-10 rounded-xl bg-brandbg text-brand flex items-center justify-center">{icon ?? <Inbox size={20} />}</div>
      <div className="font-semibold text-[13.5px]">{title}</div>
      {children && <div className="text-muted text-[12.5px] max-w-sm">{children}</div>}
      {action && <div className="mt-1">{action}</div>}
    </div>
  )
}

export function Loading({ label = 'Loading…', className = '' }: { label?: string; className?: string }) {
  return (
    <div className={`flex items-center justify-center gap-2 text-muted py-10 ${className}`}>
      <LoaderCircle size={16} className="spin" /> {label}
    </div>
  )
}

export function ErrorBox({ error, retry, className = '' }: { error: Error | string; retry?: () => void; className?: string }) {
  const msg = typeof error === 'string' ? error : error.message
  return (
    <div className={`m-4 rounded-xl border border-red-200 bg-red-50 text-red-800 px-4 py-3 flex items-start gap-3 ${className}`}>
      <CircleAlert size={18} className="shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <div className="font-semibold">Something went wrong</div>
        <div className="text-[12.5px] break-words">{msg}</div>
      </div>
      {retry && <button className="btn sm" onClick={retry}>Try again</button>}
    </div>
  )
}
